export default "__VITE_ASSET__4d0168c1__"